// src/layouts/gallery/gallery.tsx
import Label from "@a24/ui/Label";
import Richtext from "@a24/ui/Richtext";
import SanityImage from "@a24/ui/SanityImage";
import Title from "@a24/ui/Title";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Gallery = ({
  className,
  description,
  id,
  images,
  title
}) => {
  const layoutName = "Gallery";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: `grid grid-cols-12 gap-x-3 ${className} sm:gap-x-6 max-md:px-6 max-2xl:px-16`,
      "data-layout": layoutName,
      id,
      children: [
        title && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 md:col-start-1 md:col-span-7 md:row-start-1 xl:col-start-1 xl:col-span-6", children: /* @__PURE__ */ jsx(Title, { className: "heading-lg pb-10", level: "h2", text: title }) }),
        description && /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 md:col-start-1 md:col-span-5 md:row-start-2 xl:col-start-1 xl:col-span-4", children: /* @__PURE__ */ jsx(
          Richtext,
          {
            className: "freetext-richtext body-lg pb-10",
            text: description
          }
        ) }),
        images && /* @__PURE__ */ jsxs(Fragment, { children: [
          images[0] && /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 md:col-start-1 md:col-span-6 md:row-start-4 md:row-span-3", children: [
            /* @__PURE__ */ jsx(
              SanityImage,
              {
                className: "pb-3",
                sanityImageSourceData: images[0].image,
                width: 755,
                height: 503
              }
            ),
            /* @__PURE__ */ jsx(
              Label,
              {
                className: "body-2xs pb-12 md:pb-0",
                text: images[0].caption
              }
            )
          ] }),
          images[1] && /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 md:col-start-1 md:col-span-3 md:row-start-8 md:row-span-3", children: [
            /* @__PURE__ */ jsx(
              SanityImage,
              {
                className: "pb-3",
                sanityImageSourceData: images[1].image,
                width: 310,
                height: 465
              }
            ),
            /* @__PURE__ */ jsx(
              Label,
              {
                className: "body-2xs pb-12 md:pb-0",
                text: images[1].caption
              }
            )
          ] }),
          images[2] && /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 md:col-start-10 md:col-span-3 md:row-start-1 md:row-span-4", children: [
            /* @__PURE__ */ jsx(
              SanityImage,
              {
                className: "pb-3",
                sanityImageSourceData: images[2].image,
                width: 310,
                height: 465
              }
            ),
            /* @__PURE__ */ jsx(
              Label,
              {
                className: "body-2xs pb-12 md:pb-0",
                text: images[2].caption
              }
            )
          ] }),
          images[3] && /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 md:col-start-9 md:col-span-4 md:row-start-6 md:row-span-3", children: [
            /* @__PURE__ */ jsx(
              SanityImage,
              {
                className: "pb-3",
                sanityImageSourceData: images[3].image,
                width: 421,
                height: 280
              }
            ),
            /* @__PURE__ */ jsx(
              Label,
              {
                className: "body-2xs pb-12 md:pb-0",
                text: images[3].caption
              }
            )
          ] }),
          images[4] && /* @__PURE__ */ jsxs("div", { className: "col-span-full row-span-1 md:col-start-6 md:col-span-7 md:row-start-10 md:row-span-3", children: [
            /* @__PURE__ */ jsx(
              SanityImage,
              {
                className: "pb-3",
                sanityImageSourceData: images[4].image,
                width: 755,
                height: 503
              }
            ),
            /* @__PURE__ */ jsx(
              Label,
              {
                className: "body-2xs pb-12 md:pb-0",
                text: images[4].caption
              }
            )
          ] })
        ] })
      ]
    }
  );
};
var gallery_default = Gallery;

export {
  gallery_default
};
